import Crypto from "./crypto.js";
import { CryptoKey } from "./emunData";

const escapeRegExp = (string) => {
  return string.replace(/[-/\\^$*+?.()|[\]{}]/g, "\\$&");
};

const _uuid = () => {
  let d = Date.now();
  if (
    typeof performance !== "undefined" &&
    typeof performance.now === "function"
  ) {
    d += performance.now(); //use high-precision timer if available
  }
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
    var r = (d + Math.random() * 16) % 16 | 0;
    d = Math.floor(d / 16);
    return (c === "x" ? r : (r & 0x3) | 0x8).toString(16);
  });
};

// const getFocusClinic = () => {
//   let authClinics = JSON.parse(localStorage.getItem("AUTH_CLINICS") || []);
//   let clinicID = localStorage.getItem("CLINIC");
//   return authClinics.find((clinic) => {
//     return clinic._id === clinicID;
//   });
// };

const getEmulateUser = () => {
  return Crypto.decrypt(localStorage.getItem("EMULATE_USER"), CryptoKey);
};

const updatePrint = (printItems) => {
  if (!printItems) {
    printItems = [
      { id: "record", name: "醫囑", select: true },
      { id: "referral", name: "轉診單", select: false },
      { id: "drug", name: "用藥", select: true },
      { id: "drugDetail", name: "列印藥品明細", select: true },
      { id: "charge", name: "費用明細", select: true },
      { id: "showRxPrice", name: "列印藥品價格", select: false },
      { id: "EN_version", name: "英文版", select: false },
    ];
  }
  localStorage.setItem("PRINT_RECORD", JSON.stringify(printItems));
  return printItems;
};

const getPrintData = () => {
  let printItems;

  try {
    printItems = JSON.parse(localStorage.getItem("PRINT_RECORD"));
    if (!printItems.find((item) => item.id === "drugDetail")) {
      //向下相容無drugDetail
      let drugIndex = printItems.findIndex((item) => item.id === "drug");
      if (drugIndex > -1) {
        printItems.splice(drugIndex + 1, 0, {
          id: "drugDetail",
          name: "列印藥品明細",
          select: printItems[drugIndex].select,
        });
      }
    }
    // if (!printItems.find((item) => item.id === "estimate")) {
    //   //向下相容無estimate
    //   let estimateIndex = printItems.findIndex((item) => item.id === "charge");
    //   if (estimateIndex > -1) {
    //     printItems.splice(estimateIndex + 1, 0, {
    //       id: "estimate",
    //       name: "估價單",
    //       select: printItems[estimateIndex].select,
    //     });
    //   }
    // }
    if (printItems.find((item) => item.id === "estimate")) {
      //移除estimate
      let estimateIndex = printItems.findIndex(
        (item) => item.id === "estimate"
      );
      if (estimateIndex > -1) {
        printItems.splice(estimateIndex, 1);
      }
    }
    if (!printItems.find((item) => item.id === "showRxPrice")) {
      //向下相容無showRxPrice
      let rxPriceIndex = printItems.findIndex((item) => item.id === "charge");
      if (rxPriceIndex > -1) {
        printItems.splice(rxPriceIndex + 1, 0, {
          id: "showRxPrice",
          name: "列印藥品價格",
          select: false,
        });
      }
    }
    if (!printItems.find((item) => item.id === "referral")) {
      //向下相容無referral
      let index = printItems.findIndex((item) => item.id === "record");
      if (index > -1) {
        printItems.splice(index + 1, 0, {
          id: "referral",
          name: "轉診單",
          select: false,
        });
      }
    }
  } catch (e) {
    printItems = updatePrint();
  }
  return { printItems };
};

// const updateLastPassword = async (email, password) => {
//   const username = Crypto.decrypt(
//     localStorage.getItem("LAST_USERNAME"),
//     CryptoKey
//   );
//   if (username === email) {
//     localStorage.setItem("LAST_PASSWORD", Crypto.encrypt(password, CryptoKey));
//   }
// };

const hasBillItem = (record) => {
  if (
    (Array.isArray(record.chargeDivision) && record.chargeDivision.length) ||
    (Array.isArray(record.drugBag) && record.drugBag.length) ||
    // wenyilin deleted by 2024-09-23 test
    // (Array.isArray(record.controlledDrugBag) &&
    //   record.controlledDrugBag.length) ||
    (Array.isArray(record.examTask) && record.examTask.length) ||
    (Array.isArray(record.surgery) && record.surgery.length) ||
    (Array.isArray(record.surgeryConsumable) &&
      record.surgeryConsumable.length) ||
    (Array.isArray(record.vaccine) && record.vaccine.length)
  ) {
    return true;
  }
  return false;
};

const b64toBlob = (b64Data, contentType = "", sliceSize = 512) => {
  const byteCharacters = atob(b64Data);
  const byteArrays = [];

  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    const slice = byteCharacters.slice(offset, offset + sliceSize);

    const byteNumbers = new Array(slice.length);
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    byteArrays.push(byteArray);
  }

  const blob = new Blob(byteArrays, { type: contentType });
  return blob;
};

export {
  escapeRegExp,
  _uuid,
  // getFocusClinic,
  getEmulateUser,
  updatePrint,
  getPrintData,
  // updateLastPassword,
  hasBillItem,
  b64toBlob,
};
